<template>
  <section
    v-if="!ui.isLoading"
    class="main card plans section--full-width"
  >
    <header class="card-header">
      <h2>Planos Dr. Conecta</h2>
    </header>

    <article class="details">
      <article class="details__col details__col--lg">
        <header class="details__header details__header--fns">
          <h3 class="details__tit">
            Funcionalidades
          </h3>
        </header>

        <ul class="details__body">
          <li
            v-for="(feature, index) in PLANS_DATA.features"
            :key="`feature-description-${index}`"
            class="details__feature"
          >
            <span>
              {{ feature }}
            </span>
          </li>
        </ul>
      </article>

      <article
        v-for="(plan, index) in localPlans"
        :key="`plan-${index}`"
        :class="{ 'details__col--selected': plan.id === selectedPlanId }"
        class="details__col"
      >
        <header class="details__header">
          <div
            v-if="plan.hasRibon"
            class="details__ribbon"
          >
            <div class="details__ribbon-right" />
            <div class="details__ribbon-left" />
          </div>

          <div
            :class="{ 'details__header-tit--premium': plan.name !== 'GRATUITO' }"
            class="details__header-tit"
          >
            {{ plan.name }}
          </div>

          <button
            :class="{ 'details__header-btn--selected': plan.id === selectedPlanId }"
            :disabled="ui.isSaving"
            class="details__header-btn btn"
            @click="
              selectedPlan = plan.name
              selectedPlanId = plan.id
            "
          >
            <template v-if="plan.id === selected.id">
              Plano selecionado
            </template>

            <template v-if="plan.id !== selected.id">
              Selecionar plano
            </template>
          </button>

          <p class="details__header-price">
            R$ {{ plan.price | toBRL }}
          </p>

          <p class="details__header-disclaimer">
            por mês
          </p>
        </header>

        <ul class="details__body">
          <li
            v-for="(feature, j) in plan.features"
            :key="`feature-pro-${j}`"
            class="details__feature"
          >
            <div
              v-if="feature"
              class="flex items-center justify-center"
            >
              <i class="icon icon-check text-green" />
            </div>
          </li>
        </ul>
      </article>
    </article>

    <footer class="details__footer">
      <p class="m-0 p-0 text-base text-blue font-bold">
        Plano selecionado:

        <strong v-if="selectedPlanId === 1" class="text-white">
          GRATUITO
        </strong>
        <strong v-if="selectedPlanId === 9" class="text-white">
          PREMIUM
        </strong>
        <strong v-if="selectedPlanId === 10" class="text-white">
          MARKETPLACE
        </strong>
      </p>

      <button
        v-if="showButton && selectedPlanId === 1"
        :disabled="ui.isSaving"
        class="btn btn-primary"
        @click="handleConfirmation"
      >
        Contratar Plano Gratuito
      </button>

      <button
        v-if="showButton
        && selectedPlanId !== 1
        && (selected.isTrial
        || (selectedPlanId !== selected.id))"
        :disabled="ui.isSaving"
        class="btn btn-primary"
        @click="handleConfirmation"
      >
        Prosseguir
      </button>
    </footer>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import VueJwtDecode from 'vue-jwt-decode'

export default {
  name: 'DrPlansDetails',

  filters: {
    toBRL (str) {
      const money = Number(str).toFixed(2)

      return money.replace(/^(\d{1,})\.(\d{1,2})$/gmi, '$1,$2')
    }
  },

  data () {
    return {
      showBtn: false,
      selected: null,
      currentPlan: null,
      price: 0,
      selectedPlan: null,
      selectedPlanId: null,
      isMarketPlace: false,
      ui: {
        isLoading: false,
        isSaving: false
      },
      localPlans: [
        {
          name: 'GRATUITO',
          price: 0,
          features: Array(11).fill(0).map((_, i) => i < 5 ? 1 : 0),
          hasRibon: false,
          id: 1
        },
        {
          name: 'PREMIUM',
          price: 0,
          features: Array(11).fill(0).map((_, i) => i < 10 ? 1 : 0),
          hasRibon: false,
          id: 9
        },
        {
          name: 'MARKETPLACE',
          price: 0,
          features: Array(11).fill(1),
          hasRibon: true,
          id: 10
        }
      ]
    }
  },

  computed: {
    ...mapGetters({ plan: 'getPlan' }),

    showButton () {
      if (this.selected) {
        if (this.selected.id === 1 && this.selectedPlan === 'GRATUITO') {
          return false
        }

        if (this.selected.id === 9 && this.selectedPlan === 'PREMIUM') {
          return false
        }

        if (this.selected.id === 10 && this.selectedPlan === 'MARKETPLACE') {
          return false
        }
      }
      return true
    },

    whichPlan () {
      if (this.currentPlan.name === 'PREMIUM AGENDA AVAILABLE') {
        return 'MARKETPLACE'
      }

      if (this.currentPlan.name === 'PREMIUM') {
        return 'PREMIUM'
      }

      if (this.currentPlan.name === 'PRO') {
        return 'GRATUITO'
      }

      return null
    }
  },

  watch: {
    selectedPlan: {
      immediate: false,
      deep: false,
      handler (next, old) {
        if (next !== old) {
          this.$nextTick(() => {
            if (this.showButton) {
              document.querySelector('footer.details__footer')
                .scrollIntoView({ behavior: 'smooth' })
            }
          })
        }
      }
    }
  },

  created () {
    this.currentPlan = this.getCurrentPlan().then(response => { return response.data.subscription_plan })
    this.checkHealthplaceRequirements()
      .then((status) => {
        this.isMarketPlace = status

        if (this.plan.isPro) {
          this.selectedPlan = 'GRATUITO'
        } else {
          this.selectedPlan = this.plan.isPremium
            ? 'PREMIUM'
            : 'MARKETPLACE'
        }
      })
      .then(this.getPlans)
  },

  mounted () {
    this.$nextTick(() => {
      this.localPlans.find((plan) => plan.name === 'PREMIUM')
        .price = this.plan.premiumPrice

      this.localPlans.find((plan) => plan.name === 'MARKETPLACE')
        .price = this.plan.marketplacePrice
    })

    const url = '/doctor/doctor_subscription_plan'

    this.$http
      .get(url, this.$store.getters.getAuthHeader)
      .then(response => {
        this.selected = response.data.subscription_plan
        this.selectedPlanId = response.data.subscription_plan.id
      })
      .catch((err) => { return err })
  },

  methods: {
    handleConfirmation () {
      if (this.selectedPlan === 'MARKETPLACE') {
        this.ui.isSaving = true
        this.fn_SHOW_PROGRESS()

        this.checkHealthplaceRequirements()
          .then((status) => {
            if (!status) {
              this.showMarketplaceNotAbleMessage()
              return
            }
            this.doCheckout()
          })
          .finally(() => {
            this.ui.isSaving = false
            this.fn_HIDE_PROGRESS()
          })
      } else {
        this.doCheckout()
      }
    },

    getPlans () {
      const url = '/subscription_plan?itensPerPage=all'

      this.ui.isLoading = true
      this.fn_SHOW_PROGRESS()
      this.$http
        .get(url, this.$store.getters.getAuthHeader)
        .then((res) => {
          const { value: premiumPrice } = res.data.data.find((plan) => /^premium$/i.test(plan.name))
          const { value: proPrice, id: proId } = res.data.data.find((plan) => /^pro$/i.test(plan.name))
          this.$store.dispatch('setPlan', { premiumPrice, proPrice, proId })
        })
        .finally(() => {
          this.ui.isLoading = false
          this.fn_HIDE_PROGRESS()
        })
    },

    doCheckout () {
      if (this.selectedPlan === 'GRATUITO') {
        this.$store.dispatch('setModalConfirm', {
          title: 'Atenção',
          body: `Tem certeza que deseja contratar o plano GRATUITO?`,
          confirmText: 'Confirmar',
          cancelText: 'Cancelar',
          beforeClose: (v) => {
            this.$store.dispatch('setModalConfirm')

            if (v) {
              this.ui.isSaving = true
              this.fn_SHOW_PROGRESS()
              this.confirmPayment()
                .then(() => this.refreshToken())
                .then(() => this.showConfirmationMessage())
                .then(() => this.$router.push({ name: 'DoctorPlans' }))
                .catch(err => this.fn_HANDLE_ERROR(err))
                .finally(() => {
                  this.ui.isSaving = false
                  this.fn_HIDE_PROGRESS()
                })
            }
          },
          size: 'md',
          active: true
        })
      } else {
        this.ui.isSaving = true
        this.fn_SHOW_PROGRESS()
        this.$router.push({name: 'DoctorPlansCheckout'})
      }
    },
    confirmPayment () {
      const url = '/doctor/doctor_subscription_plan'

      const data = {
        'doctor_subscription_plan': {
          subscriptionPlan: this.selectedPlanId
        }
      }

      return new Promise((resolve, reject) => {
        this.$http
          .post(url, data, this.$store.getters.getAuthHeader)
          .then(resolve)
          .catch((err) => reject(err))
      })
    },

    getCurrentPlan () {
      const url = '/doctor/doctor_subscription_plan'

      return new Promise((resolve, reject) => {
        this.$http
          .get(url, this.$store.getters.getAuthHeader)
          .then(resolve)
          .catch((err) => reject(err))
      })
    },

    refreshToken () {
      return new Promise((resolve, reject) => {
        this.$http
          .post(
            '/api/token/refresh',
            { 'refresh_token': this.$store.getters.getRefreshToken },
            this.$store.getters.getAuthHeader
          )
          .then((res) => {
            this.$store.dispatch('setAuth', res.data)

            const roles = VueJwtDecode.decode(res.data.token).roles
            const isPro = roles.some((role) => /doctor_pro/gi.test(role))
            const isPremium = roles.some((role) => /doctor_premium/gi.test(role)) ||
              roles.some((role) => /doctor_facilities/gi.test(role))
            this.$store.dispatch('setPlan', { isPro, isPremium })

            resolve()
          })
          .catch((err) => reject(err))
      })
    },

    showConfirmationMessage () {
      this.$store.dispatch('setModalAlert', {
        title: 'Sucesso',
        body: 'Plano contratado com sucesso.',
        size: 'md',
        active: true,
        callback: console.log('vixe')
      })
    },

    showMarketplaceNotAbleMessage () {
      this.$store.dispatch('setModalAlert', {
        title: 'Erro',
        body: 'Você não atendeu os requisitos para assinar o plano Marketplace.',
        size: 'md',
        active: true
      })
    },

    checkHealthplaceRequirements () {
      const url = '/doctor/doctor_health_place/has_agenda_available'

      return new Promise((resolve) => {
        this.$http
          .get(url, this.$store.getters.getAuthHeader)
          .then((res) => {
            resolve(Boolean(res.data))
          })
          .catch(() => resolve(false))
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '$vars';

.details {
  @apply flex flex-row items-start justify-between;
  padding: 0 30px 30px 30px;

  &__col {
    @apply flex flex-col items-start justify-start;
    @apply rounded rounded-lg;
    align-self: stretch;
    border: 1px solid rgb(226, 232, 240);
    flex: 0 2 15rem;
    transition: all ease 0.3s;

    &:not(&--lg) {
      @apply ml-4;
    }

    &--lg {
      flex: 1 0 calc(40%);
    }

    &--selected {
      box-shadow: 0 5px 10px rgba(0,0,0,.3);
      transition: all ease 0.3s;
    }
  }

  &__header {
    @apply w-full flex flex-col items-center justify-start;
    @apply rounded-t-lg relative;
    background-color: rgb(241, 245, 244);
    height: 11rem;

    &--fns {
      @apply flex-row items-center justify-start p-6;
    }

    &-tit {
      @apply rounded-t-lg w-full;
      @apply p-2;
      background: $color-admin;
      color: white;
      font-size: 1rem;
      font-weight: bold;
      text-align: center;

      &--premium {
        background: $color-gradient;
      }
    }

    &-btn {
      @apply flex items-center justify-center;
      @apply rounded rounded-full py-2 px-6 mt-6;
      background: white;
      border: 1px solid $color-navy;
      color: $color-navy;
      font-size: 0.8rem;
      font-weight: bold;
      width: 80%;

      &:hover {
        background: #edf8fa;
      }

      &--selected {
        background: $color-navy;
        color: white;

        &:hover {
          background: $color-navy;
          color: white;
        }
      }
    }

    &-price {
      @apply p-0 m-0 pt-2;
      @apply text-lg font-bold;
    }

    &-disclaimer {
      @apply p-0 m-0 pt-1;
      @apply text-sm;
      color: $color-blue;
    }
  }

  &__ribbon {
    @apply absolute;
    background: $color-orange;
    height: 3rem;
    right: 0.5rem;
    top: -3px;
    width: 1.2rem;

    &:after {
      @apply absolute;
      box-shadow: 1px 0 0.5px 0.5px rgba(0, 0, 0, 0.2);
      content: '';
      height: 4rem;
      right: 0;
      top: 0;
      width: 1px;
    }

    &-left {
      @apply block;
      border: 0.5rem solid transparent;
      border-left-color: $color-orange;
      border-top-color: $color-orange;
      height: 0;
      position: absolute;
      top: 100%;
      width: 0;
    }

    &-right {
      @apply block;
      border: 0.5rem solid transparent;
      border-right-color: $color-orange;
      border-top-color: $color-orange;
      height: 0;
      position: absolute;
      right: 0;
      top: 100%;
      width: 0;
    }
  }

  &__tit {
    color: #4a4a4a;
    font-family: $font1;
  }

  &__body {
    @apply p-0 m-0 w-full list-none;
    @apply flex flex-col items-start justify-start;
  }

  &__feature {
    @apply w-full p-0 m-0 px-2 py-3;
    height: 2.5rem;

    &:not(:last-of-type) {
      border-bottom: 1px dashed #e1e1e1;
    }

    &:last-of-type {
      @apply font-bold;
    }
  }

  &__footer {
    @apply rounded rounded-lg p-4;
    @apply flex items-center justify-between;
    background: $color-navy;
    margin: 0 30px 30px 30px;
    min-height: 4rem;
  }
}
</style>
